import parsePhoneNumber from 'libphonenumber-js'
import { getMnoConfig } from '@/context/mno/configs';

// Get country code from MNO config
export const getCountryCode = () => getMnoConfig().countryCode;

export const clearedNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\s+/g, '');
};

export const formatWithCountryCode = (phoneNumber: string) => {
  return getCountryCode() + clearedNumber(phoneNumber);
};

export const trimCountryCode = (phoneNumber: string) => {
  return phoneNumber.replace(getCountryCode(), "");
};

export const displayFormattedPhoneNumber = (phoneNumber: string) => {
  const number = parsePhoneNumber(`+${phoneNumber}`);
  return number?.formatInternational() ?? "";

}; 